module.exports = __webpack_public_path__ + "static/img/GM.88b850e8.png";